/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
  bearer: string;
};

type ReturnTuple = [vp.DeleteAccountUserResponse, (requestParams: vp.DeleteAccountUserRequest) => void, () => void];

function usePostDeleteAccountUser({ api, bearer }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.DeleteAccountUserRequest>();
  const [response, setResponse] = useState<vp.DeleteAccountUserResponse>({
    Success: false,
    ErrorMessage: '',
    UserID: '',
    IsActive: false,
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.DeleteAccountUserRequest) => {
      setDataFetchingInfo(true, 'deleting user', 'fullScreen');
      const res = await api.postDeleteAccountUser(requestParams, bearer, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.DeleteAccountUserRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        UserID: '',
        IsActive: false,
      });
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostDeleteAccountUser);
